/**
 * Style for react-treebeard
 */
export default {
  tree: {
    base: {
      listStyle: 'none',
      backgroundColor: '#ffffff',
      margin: 0,
      padding: 0,
      color: '#222222',
      fontSize: '13px',
      minWidth: '100%',
      display: 'inline-block'
    },
    node: {
      base: {
        position: 'relative',
        whiteSpace: 'nowrap'
      },
      link: {
        cursor: 'pointer',
        padding: '0px 5px',
        display: 'flex',
        ':hover': {
          backgroundColor: '#EDF0F2'
        }
      },
      activeLink: {
        backgroundColor: '#0696D7',
        color: '#FFFFFF',
        fontWeight: '800',
        minWidth: '100%',
        display: 'flex',
        ':hover': {
          backgroundColor: '#0696D7'
        }
      },
      toggle: {
        base: {
          position: 'relative',
          display: 'inline-block',
          verticalAlign: 'top',
          marginLeft: '-5px',
          height: '35px',
          width: '35px'
        },
        wrapper: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          margin: '-7px 0 0 -3px',
          height: '14px'
        },
        height: 10,
        width: 6,
        arrow: {
          fill: '#819099',
          strokeWidth: 0
        },
        activeArrow: {
          fill: 'currentColor'
        }
      },
      header: {
        base: {
          display: 'block',
          verticalAlign: 'top',
          flexGrow: 1
        },
        connector: {
          width: '2px',
          height: '12px',
          borderLeft: 'solid 2px black',
          borderBottom: 'solid 2px black',
          position: 'absolute',
          top: '0px',
          left: '-21px'
        },
        title: {
          lineHeight: '35px',
          verticalAlign: 'middle',
          whiteSpace: 'nowrap',
          marginRight: '15px'
        },
        titleNoToggle: {
          marginLeft: '30px'
        }
      },
      subtree: {
        listStyle: 'none',
        paddingLeft: '21px'
      },
      loading: {
        color: '#E2C089'
      }
    }
  }
};
